<template>
  <div class="route-container">
    <h2>Benutzerverwaltung</h2>
    <div class="user-management-container">
      <treeselect 
        id="user-select"
        v-model="selectedUser" 
        placeholder="User..."
        :options="userList"
        :loadOptions="null"
        :multiple="false"
        :disable-branch-nodes="true"
        required
      />

      <template v-if="selectedUser && selectedUserPermissions">
        <div v-for="permission in permissionList">
          <BFormCheckbox 
            :model-value="getUserPermissionValue(permission.PermissionId)"
            :unchecked-value="true"
            @change="setPermissionOfUser(permission.PermissionId)"
          >
            <span style="user-select: none;">{{ getTranslatedPermissionText(permission.Name) }}</span>
          </BFormCheckbox>
        </div>
      </template>
      <template v-else>
        <div v-for="permission in permissionList">
          <BFormCheckbox 
            :disabled="true"
          >
            <span style="user-select: none;">{{ getTranslatedPermissionText(permission.Name) }}</span>
          </BFormCheckbox>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import UsersService from '../services/UsersService';
import Treeselect from '@zanmato/vue3-treeselect'

export default {
  name: 'UserManagement',
  components: {
    Treeselect,
  },
  data() {
    return {
      userList: [],
      permissionList: [],
      selectedUser: null,
      selectedUserPermissions: null
    }
  },
  created() {
    this.getUserList();
    this.getPermissionList();
  },
  watch: {
    selectedUser() {
      this.getPermissionsOfUser();
    }
  },
  methods: {
    getTranslatedPermissionText(permissionName) {
      let res = null;
      switch(permissionName) {
        case "AgencyCostsAndInvoicing": 
          res = "Agenturkosten/Rechnungsstellung";
          break;
        case "AllocationAsProjectManager": 
          res = "Zuweisung als Projektmanager";
          break;
        case "Archive": 
          res = "Archiv";
          break;
        case "CostCenterManagement": 
          res = "Kostenstellenverwaltung";
          break;
        case "Field": 
          res = "Feld";
          break;
        case "InvoiceManagement": 
          res = "Rechnungsverwaltung";
          break;
        case "Management": 
          res = "Geschäftsführung";
          break;
        case "OrderManagement": 
          res = "Auftragsverwaltung";
          break;
        case "ProjectManagement": 
          res = "Projektmanagement";
          break;
        case "QualityAssurance": 
          res = "Qualitätssicherung";
          break;
        case "Sales": 
          res = "Vertrieb";
          break;
        case "ShopperCosts": 
          res = "Testkundenkosten";
          break;
        case "UserManagement": 
          res = "Benutzerverwaltung";
          break;
        default:
          break;
      }
      return res;
    },
    getUserPermissionValue(permissionId) {
      var permission = this.selectedUserPermissions?.find(x => x.PermissionId == permissionId);
      return !!permission;
    },
    getUserList() {
      UsersService.getUserList()
      .then(res => {
        this.userList = [];
        if(res.data === '') return;
        this.userList = res.data;
      })
    },
    getPermissionList() {
      UsersService.getPermissionList()
      .then(res => {
        this.permissionList = [];
        if(res.data === '') return;
        this.permissionList = res.data;
      })
    },
    getPermissionsOfUser() {
      if(!this.selectedUser) return;
      this.selectedUserPermissions = null;
      UsersService.getPermissionsOfUser(this.selectedUser)
      .then(res => {
        if(res.data) this.selectedUserPermissions = res.data;
        else this.selectedUserPermissions = [];
      })
    },
    setPermissionOfUser(permissionId) {
      if(!this.selectedUser) return;
      UsersService.setPermissionOfUser({ "userId": this.selectedUser, "permissionId": permissionId})
      .catch(err => {
        console.error(err);
      })
    }
  }
}
</script>

<style lang="css" scoped>
  .user-management-container {
    padding: 15px;
    background: #f6f6f6;
    border: 1px solid lightgray;
  }
</style>
